import { Settings } from 'luxon'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const useLanguage = (): [string, (language: string) => void] => {
    const { i18n } = useTranslation()

    const changeLanguage = useCallback(
        (language: string) => {
            i18n.changeLanguage(language)
            Settings.defaultLocale = language
        },
        [i18n]
    )

    return [i18n.language, changeLanguage]
}

export default useLanguage
